import { createClient } from '@supabase/supabase-js';

export const publicSupabase = createClient(
  "https://gxjhhfllwtodskynhorr.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd4amhoZmxsd3RvZHNreW5ob3JyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE0OTg2NjAsImV4cCI6MjA1NzA3NDY2MH0.mg_8gXMXwEgZ0Cng7TVzm9q3-7xM6eQzCkTiF4CTaGc",
  {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false
    }
  }
); 